<template>
  <div
    :class="[
      'audio-player-btn-wrap',
      { 'audio-player-btn-wrap_circle': !loading },
    ]"
  >
    <v-progress-circular
      v-if="loading"
      indeterminate
      :color="color"
      size="20"
      width="2"
    ></v-progress-circular>

    <template v-else>
      <slot v-if="!playing" name="play-btn">
        <v-btn
          class="audio-player-play-btn"
          :color="color"
          icon
          @click.stop="$emit('play', $event)"
        >
          <v-icon :color="color">
            mdi-play
          </v-icon>
        </v-btn>
      </slot>

      <slot v-else name="pause-btn">
        <v-btn
          class="audio-player-pause-btn"
          :color="color"
          icon
          @click.stop="$emit('pause', $event)"
        >
          <v-icon :color="color">
            mdi-pause
          </v-icon>
        </v-btn>
      </slot>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'PlayPauseButton',
    props: {
      color: String,
      loading: {
        type: Boolean,
        default: false,
      },
      playing: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['play', 'pause'],
  }
</script>

<style lang="less" scoped>
.audio-player {
  &-btn-wrap {
    display: inline-flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    transition: background-color 0.5s;
  }

  &-play-btn {
    touch-action: none;
    user-select: none;
    -webkit-user-drag: none;
  }

  &-pause-btn {
    touch-action: none;
    user-select: none;
    -webkit-user-drag: none;
  }
}
</style>
